var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileplaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 124,
    rx: 62,
    fill: "#FFDBBC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 90C38.6753 81.329 49.7746 76 62 76C74.2254 76 85.3247 81.329 93.5 90M77.75 46.25C77.75 54.9485 70.6985 62 62 62C53.3015 62 46.25 54.9485 46.25 46.25C46.25 37.5515 53.3015 30.5 62 30.5C70.6985 30.5 77.75 37.5515 77.75 46.25Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileplaceholder);
export default __webpack_public_path__ + "static/media/Profileplaceholder.7fe3661740359fa81e3793aaff7678cb.svg";
export { ForwardRef as ReactComponent };